module.exports = __webpack_public_path__ + "assets/code.21a8c1ce.svg";